import { jsx as _jsx } from "react/jsx-runtime";
const BookPage = ({ children, className = '' }) => {
    return (_jsx("div", { className: `book-page bg-[#FAF7F2] text-[#4A4A4A] p-12 font-body ${className}`, style: {
            width: '177.8mm', // 7 inches
            height: '254mm', // 10 inches
            minWidth: '177.8mm',
            minHeight: '254mm',
            maxWidth: '177.8mm',
            maxHeight: '254mm',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            overflow: 'hidden' // Hidden for proper page boundaries
        }, children: _jsx("div", { className: "flex-1 overflow-hidden", style: {
                display: 'flex',
                flexDirection: 'column',
                minHeight: 0,
                width: '100%',
                height: '100%'
            }, children: children }) }));
};
export default BookPage;
